import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import endpoints from "../../../endpoint";
import { toast } from "react-toastify";
import { Card, CardContent, CardMedia, Typography, CircularProgress } from "@mui/material";
import { getImageUrl } from "../../../utils/helpFunction";

const ShowTheAnalystById = () => {
    const { analystId } = useParams();
    const [analyst, setAnalyst] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchAnalystById = async () => {
            try {
                const response = await axios.get(
                    `${endpoints.serverBaseUrl}api/market/${analystId}`,
                    {
                        withCredentials: true,
                        headers: {
                            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
                        },
                    }
                );
                setAnalyst(response.data.data);
            } catch (error) {
                toast.error("Failed to fetch analyst data.");
            } finally {
                setLoading(false);
            }
        };

        fetchAnalystById();
    }, [analystId]);

    if (loading) {
        return (
            <div className="flex justify-center items-center min-h-screen">
                <CircularProgress />
            </div>
        );
    }

    return (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100vh", backgroundColor: "#f5f5f5" }}>
            {analyst ? (
                <Card sx={{ boxShadow: 3, borderRadius: 3, padding: 2 }}>
                    <CardMedia
                        component="img"
                        height="200"
                        image={getImageUrl(analyst.imageId)}
                        alt={analyst.title}
                    />
                    <CardContent>
                        <Typography variant="h5" component="div" gutterBottom>
                            {analyst.title}
                        </Typography>
                        <Typography variant="subtitle1" color="textSecondary">
                            {analyst.category}
                        </Typography>
                        <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
                            {analyst.description}
                        </Typography>
                        <Typography variant="body2" color="textSecondary" sx={{ mt: 2 }}>
                            <strong>Email:</strong> {analyst.teacherId?.email}
                        </Typography>
                        <Typography variant="caption" color="textSecondary" sx={{ mt: 1, display: "block" }}>
                            Created on: {new Date(analyst.createdAt).toLocaleDateString()}
                        </Typography>
                    </CardContent>
                </Card>
            ) : (
                <Typography color="error">No analyst data found.</Typography>
            )}
        </div>
    );
};

export default ShowTheAnalystById;
